import { render, staticRenderFns } from "./ktxc-SINGLE_CHOICE.vue?vue&type=template&id=24ab59ef&scoped=true"
import script from "./ktxc-SINGLE_CHOICE.vue?vue&type=script&lang=js"
export * from "./ktxc-SINGLE_CHOICE.vue?vue&type=script&lang=js"
import style0 from "./ktxc-SINGLE_CHOICE.vue?vue&type=style&index=0&id=24ab59ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab59ef",
  null
  
)

export default component.exports